<script lang="ts">
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const { icon, label }: { icon: string; label: string } = $props();
</script>

<li class="bg-white rounded-full flex gap-2 items-center h-7.5 px-[calc(0.5rem-1px)] border border-fcrlightgray">
	<div aria-hidden="true" class="bg-fcrbeige rounded-full flex items-center justify-center size-4.5">
		<Icon {icon} class="size-2.5 text-fcrsagegreen" />
	</div>
	<div class="text-xs/none font-medium pr-1">
		<Formatted text={label} />
	</div>
</li>
